var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-progress g-tip-wrap hide",class:{
    hover: _vm.hover,
    animation: _vm.animation,
    run: _vm.percent !== _vm.totalPercent,
    hidden: _vm.hidden
  }},[_c('span',{staticClass:"current g-tip bottom",style:({ left: _vm.percent + '%' })},[_vm._v(_vm._s(_vm.current))]),_c('div',{staticClass:"progress",class:_vm.type,style:({ width: _vm.percent + '%' })}),_c('span',{staticClass:"total g-tip top",style:({ left: _vm.percent + '%' })},[_vm._v(_vm._s(_vm.total))])])}
var staticRenderFns = []

export { render, staticRenderFns }